import type { PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { Form, TextInput } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useOrgSession from '@/hooks/use-org-session';
export type CopyHandler = {
  launch: () => void;
};
type FormData = {
  name: string;
  tenantId: string;
};
export type FormProps = {
  onSubmit: (data: FormData & {
    tenantName: string;
  }) => void;
  playbook: PlaybookVersionNoGraph;
  tenants: {
    label: string;
    value: string;
  }[];
};
const CopyForm = ({
  onSubmit,
  playbook,
  tenants
}: FormProps) => {
  const {
    t
  } = useTranslation('playbooks', {
    keyPrefix: 'copy'
  });
  const org = useOrgSession();
  const form = useForm<FormData>({
    defaultValues: {
      name: t($ => $.form.name.base, {
        name: playbook.name
      }),
      tenantId: tenants.find(tenant => tenant.value === org.dangerouslyCastedData.id)?.value
    }
  });
  const selectedTenantId = form.watch('tenantId');
  const selectedTenant = tenants.find(tenant_0 => tenant_0.value === selectedTenantId);
  const handleSubmit = (data: FormData) => {
    onSubmit({
      ...data,
      tenantName: selectedTenant?.label || ''
    });
  };
  return <FormProvider {...form}>
      <form aria-label="Copy playbook" data-testid="copy-playbook-form" id="copy-playbook-form" onSubmit={form.handleSubmit(handleSubmit)}>
        <div className="flex gap-6 flex-col">
          <p className="text-body-2">{t($_0 => $_0.form.description)}</p>
          <TextInput autoFocus label={t($_1 => $_1.form.name.label)} placeholder={t($_2 => $_2.form.name.placeholder)} {...form.register('name', {
          required: true
        })} />
          {tenants.length > 1 && <Form.Select<FormData> name="tenantId" label={t($_3 => $_3.form.tenant.label)} rules={{
          required: true
        }} options={tenants.map(tenant_1 => ({
          label: tenant_1.label,
          value: tenant_1.value
        }))} />}
        </div>
      </form>
    </FormProvider>;
};
export default CopyForm;